<template>
  <div>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <base-list-management
      ref="baseListManagementRef"
      :configData.sync="configData"
    >
      <template v-slot:custom-export>
        <PublicExport
          exportTitle="核销记录导出"
          exportTemplate="CouponUserVerify"
          :getSearchData="getExportParams"
          templateCode="vehicle-customer-verify-coupon-page"
          :getSearchCondition="getSearchCondition"
        >
          <template v-slot:export-button="{ openDialog, exportBtnText }">
            <el-button type="primary" size="small" @click="openDialog">
              {{ exportBtnText }}
            </el-button>
          </template>
        </PublicExport>
      </template>
    </base-list-management>
    <DeductionDetailDialog
      :visible.sync="deductionDialog.visible"
      :middleSubOrderId="currentMiddleSubOrderId"
    />
  </div>
</template>

<script>
import DeductionDetailDialog from '../grantRecord/components/DeductionDetailDialog.vue'
// eslint-disable-next-line import/no-cycle
import { configDataFn } from '../config/grantRecordList'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  name: 'CouponVerifyRecord',
  components: {
    DeductionDetailDialog,
  },
  data() {
    const initialFormData = {}
    if (this.$route.query.couponId !== undefined && this.$route.query.couponId !== null) {
      initialFormData.couponId = String(this.$route.query.couponId)
    }
    if (this.$route.query.activityId !== undefined && this.$route.query.activityId !== null) {
      initialFormData.couponTemplateId = String(this.$route.query.activityId)
    }
    if (this.$route.query.couponTemplateName !== undefined && this.$route.query.couponTemplateName !== null) {
      initialFormData.couponTemplateName = String(this.$route.query.couponTemplateName)
    }
    return {
      configData: configDataFn({
        activeTab: 'verify',
        couponTemplateId: this.$route.query.activityId || '',
        hideVerifySourceFilter: true,
        initialFormData,
        onShowDeductionDetail: this.handleShowDeductionDetail,
        onJumpDriverList: this.handleJumpDriverList,
        onJumpCouponActivity: this.handleJumpCouponActivity,
        onJumpOrderList: this.handleJumpOrderList,
        createElement: this.$createElement,
      }),
      currentMiddleSubOrderId: '',
      deductionDialog: {
        visible: false,
      },
    }
  },
  methods: {
    getExportParams() {
      if (!this.$refs.baseListManagementRef) return {}
      return this.$refs.baseListManagementRef.getParams()
    },
    getSearchCondition() {
      const formList = this.configData?.formData?.list || []
      const model = this.configData?.formData?.formProps?.model || {}
      const condition = formList.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = model[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      condition.push({
        label: '记录类型',
        matchValue: '核销记录',
      })
      return condition
    },
    handleShowDeductionDetail(row) {
      const { middleSubOrderId } = row
      if (!middleSubOrderId || middleSubOrderId === '--') {
        this.$message.warning('缺少中台子单ID，无法查询抵扣明细')
        return
      }
      this.currentMiddleSubOrderId = middleSubOrderId
      this.deductionDialog.visible = true
    },
    handleJumpDriverList(customerName) {
      this.$router.push({
        path: '/driver/customerManage',
        query: {
          type: 'person',
          customerName,
        },
      })
    },
    handleJumpCouponActivity(activityId) {
      this.$router.push({
        path: '/activity/coupon/list',
        query: {
          activityId,
        },
      })
    },
    handleJumpOrderList(orderId) {
      this.$router.push({
        path: '/underLease/underLeaseOrder',
        query: {
          activeName: 'personal',
          childActiveName: '2',
          query: JSON.stringify({
            search: {
              id: String(orderId),
            },
          }),
        },
      })
    },
  },
}
</script>
